import React, { useState } from "react";
import { Button, Text } from "@shoptet/ui";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { WizardStepT } from "../graphql/generated/graphql";
import { useWizardState } from "../hooks/useWizardState";
import { ModalWrapper } from "./ModalWrapper";

type WizardHeaderProps = {
  showBackToDashboardButton?: boolean;
};

const WizardHeader = ({ showBackToDashboardButton = true }: WizardHeaderProps) => {
  const { t } = useTranslation("translation", { keyPrefix: "Components.Wizard Header" });
  const { googleWizardFinished, metaWizardFinished } = useWizardState();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleHelpClick = () => {
    window.open(t("Help url"), "_blank", "noopener,noreferrer");
  };

  const handleBackToDashboard = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleGoToDashboard = () => {
    navigate(`/${WizardStepT.DashboardT}`);
    setIsModalOpen(false);
  };

  const showBackButton = showBackToDashboardButton && (googleWizardFinished || metaWizardFinished);

  return (
    <>
      <div style={{ display: "flex", justifyContent: "flex-end", gap: "16px", marginBottom: "12px" }}>
        {showBackButton && (
          <Button size="md" variant="secondary" onClick={handleBackToDashboard}>
            {t("Back to Dashboard")}
          </Button>
        )}
        <Button iconRight="shp-helpdesk" size="md" variant="secondary" onClick={handleHelpClick}>
          {t("Help")}
        </Button>
      </div>

      <ModalWrapper isOpen={isModalOpen} title={t("Modal.Title")} maxWidth onClose={handleCloseModal}>
        <Text>{t("Modal.Text")}</Text>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px", marginTop: "24px" }}>
          <Button variant="secondary" onClick={handleCloseModal}>
            {t("Modal.Close")}
          </Button>
          <Button variant="primary" onClick={handleGoToDashboard}>
            {t("Modal.Go to Dashboard")}
          </Button>
        </div>
      </ModalWrapper>
    </>
  );
};

export default WizardHeader;
